import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d1677d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewInput" }
const _hoisted_2 = {
  key: 0,
  class: "NewInput__name"
}
const _hoisted_3 = { class: "NewInput__control" }
const _hoisted_4 = {
  key: 0,
  class: "control__icon icon--left"
}
const _hoisted_5 = ["autocomplete", "disabled", "placeholder", "type", "value"]
const _hoisted_6 = {
  key: 2,
  class: "control__placeholder"
}
const _hoisted_7 = {
  key: 1,
  class: "NewInput__hint"
}
const _hoisted_8 = {
  key: 2,
  class: "NewInput__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (Boolean(_ctx.name))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.name), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.$slots['icon-left'])
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "icon-left", {}, undefined, true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots['icon-right'])
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["control__icon icon--right", { 'cursor-pointer': _ctx.iconRightClickable }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitClickIconRight && _ctx.emitClickIconRight(...args)))
          }, [
            _renderSlot(_ctx.$slots, "icon-right", {}, undefined, true)
          ], 2))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(["control__input", {
                    'input--invalid': _ctx.isInvalid,
                    'input--icon-left': _ctx.$slots['icon-left'] && !_ctx.$slots['icon-right'],
                    'input--icon-right': _ctx.$slots['icon-right'] && !_ctx.$slots['icon-left'],
                    'input--icons': _ctx.$slots['icon-right'] && _ctx.$slots['icon-left'],
                    'input--freeze': _ctx.freeze,
                }]),
        autocomplete: _ctx.autocomplete,
        disabled: _ctx.disabled || _ctx.freeze,
        placeholder: _ctx.placeholder,
        type: _ctx.type,
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitInput && _ctx.emitInput(...args))),
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitChange && _ctx.emitChange(...args))),
        value: _ctx.value
      }, null, 42, _hoisted_5), [
        [_directive_maska, _ctx.maska]
      ]),
      (_ctx.placeholder)
        ? (_openBlock(), _createElementBlock("label", _hoisted_6, _toDisplayString(_ctx.placeholder), 1))
        : _createCommentVNode("", true)
    ]),
    (Boolean(_ctx.hint))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.hint), 1))
      : _createCommentVNode("", true),
    (Boolean(_ctx.validationErrors.length))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.getValidationMessage(_ctx.validationErrors)), 1))
      : _createCommentVNode("", true)
  ]))
}